export const CALL_FOR_HELP_ENDPOINTS = {
  GETSURVEYS: "/survey-manager/get-surveys",
  SUBMIT: "/survey-manager/callforhelp-submit",
  UPLOAD_ATTACHMENT: (companyId) =>
    `/files/upload/batch/${companyId}?subfolder=feedback`,
  DELETE_ATTACHMENT: (fileId) => `/files/${fileId}`,
};
